import React from 'react';
import './index.less';

const scanSuccess = require('@/public/assets/qrcode/扫码成功.png');
const scanSuccess2x = require('@/public/assets/qrcode/扫码成功@2x.png');
const scanSuccess3x = require('@/public/assets/qrcode/扫码成功@3x.png');

const QRCodeScaned = () => (
    <img
        className="qr-code-scaned"
        srcSet={`${scanSuccess},
                ${scanSuccess2x} 2x,
                ${scanSuccess3x} 3x,`}
        src={scanSuccess3x}
        alt="扫码成功"
    />
);
export default QRCodeScaned;
